import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const UserActions = ({ basePath = '', data = {} }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

UserActions.propTypes = {
  // eslint-disable-next-line react/require-default-props
  basePath: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.shape({}),
};

export default UserActions;
